import { render, staticRenderFns } from "./BetgameName.vue?vue&type=template&id=2e98253c&scoped=true"
import script from "./BetgameName.vue?vue&type=script&lang=js"
export * from "./BetgameName.vue?vue&type=script&lang=js"
import style0 from "./BetgameName.vue?vue&type=style&index=0&id=2e98253c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e98253c",
  null
  
)

export default component.exports